import { change } from 'redux-form';

export const formDependencies = ({ dispatch, section, field, value }) => {
	dispatch(change(section, field, value));
};
